import Mail from "./../images/mail.png";
import Linkedin from "./../images/linkedin.png";
import Youtube from "./../images/youtube.png";
import Github from "./../images/github.png";
import Instagram from "./../images/instagram.png";

const SocialsData = [
  {
    id: 1,
    title: "EMAIL",
    color: "blue",
    link: "mailto:dhakatedeep909@gmail.com",
    img: Mail,
    width: "30px",
  },
  {
    id: 2,
    title: "LINKEDIN",
    color: "#0072B1",
    link: "https://www.linkedin.com/in/deep-dhakate-6ba5b7214/",
    img: Linkedin,
    width: "25px",
  },
  {
    id: 3,

    title: "GITHUB",
    color: "#9d9d9d44",
    link: "https://github.com/InTruder-Sec",
    img: Github,
    width: "30px",
  },
  {
    id: 3,
    title: "YOUTUBE",
    color: "red",
    link: "https://www.youtube.com/@InTruderSecurity",
    img: Youtube,
    width: "30px",
  },
  {
    id: 4,
    title: "INSTAGRAM",
    color: "#dd2a7b",
    link: "https://instagram.com/deep__dhakate",
    img: Instagram,
    width: "30px",
  },
];

export default SocialsData;
